import state from './cbtState';
import mutations from './cbtMutations';
import getters from './cbtGetters';
import actions from './cbtActions';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
